import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import { Flex, Image, Box, Grid, GridItem, Icon, Text } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { useInView } from "framer-motion";

const Section1 = () => {
  const ref = useRef(null);
  const isInView = useInView(ref);
  const [currentColor, setCurrentColor] = useState("white");
  const colors = ["#ff00ff", "#6b32e3", "#20cc55", "#22e9a0"]; // Colors to sample through
  const transitionDuration = 2000;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentColor((prevColor) => {
        const currentIndex = colors.indexOf(prevColor);
        const nextIndex = (currentIndex + 1) % colors.length;
        const nextColor = colors[nextIndex];

        if (nextColor === colors[colors.length - 1]) {
          clearInterval(interval); // Stop the interval once the final color is reached
        }

        return nextColor;
      });
    }, transitionDuration);

    return () => {
      clearInterval(interval);
    };
  }, []);
  return (
    <>
      <Flex
        mt="100px"
        w="100%"
        alignItems="center"
        justifyContent="center"
        ref={ref}
      >
        <Flex
          p={{ base: "30px", md: "100px" }}
          alignItems={{
            base: "space-between",
            md: "center",
            lg: "space-between",
          }}
          justifyContent={{
            base: "space-between",
            md: "center",
            lg: "space-between",
          }}
          flexDir={{ base: "column", md: "column", lg: "row" }}
        >
          <Flex
            w="100%"
            flexDir="column"
            alignItems="flex-start"
            justifyContent="flex-start"
          >
            <Box
              style={{
                transform: isInView ? "none" : "translateY(-200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
              w={{ base: "100%", md: "100%", lg: "50%" }}
              fontSize={{ base: "30px", md: "40px" }}
            >
              Track everything about your wallet.
            </Box>

            <Box color="gray.500" w={{ base: "100%", md: "90%" }} mt="20px">
              See ALL your coins, NFTs and transactions in a simple tab view
              that makes it easily accessible from only one page and one browser
              tab.
            </Box>
          </Flex>

          <Suspense fallback={<div>Loading...</div>}>
            <Image
              style={{
                transform: isInView ? "none" : "translateY(200px)",
                opacity: isInView ? 1 : 0,
                transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
              }}
              mt={{ base: "20px", md: "40px", lg: "0px" }}
              w={{ base: "100%", md: "50%" }}
              border="6px solid #131014"
              boxSize={{ base: "100%", md: "100%", lg: "50%" }}
              src={"https://i.imgur.com/wNElhrq.gif"}
              borderRadius="20px"
            />
          </Suspense>
        </Flex>
      </Flex>
    </>
  );
};

export default Section1;
